import type { StoreItemType } from '../apis/client-side/item/type';

export const nickDecoTextColor: { [key: string]: string } = {
  '1': '#005246',
  '2': '#ffffff',
  '3': '#ff6d97',
  '4': '#674600',
  '5': '#ffffff',
  '6': '#005246',
  '7': '#ffe600',
  '8': '#ffffff',
  '9': '#ffffff',
  '10': '#8d5500',
  '11': '#e9572c',
  '12': '#ffffff',
  '13': '#0a3b84',
  '14': '#00a56b',
  '15': '#18765e',
  '16': '#087273',
  '17': '#ffffff',
  '18': '#d2ff00',
  '19': '#fff',
  '20': '#FFE600',
  '21': '#000',
  '22': '#01FF49',
  '23': '#FAFF00',
  '24': '#000',
  '25': '#1C3E00',
  '26': '#FFBE00',
  '27': '#00095F',
  '28': '#FFFFFF',
  '29': '#FF0067',
  '30': '#000000',
  '31': '#000000',
  '32': '#FFFFFF',
  '33': '#FFFFFF',
  '34': '#000000',
  '35': '#000000',
  '36': '#000000',
  '37': '#000000',
  '38': '#FFFFFF',
  '39': '#FFFFFF',
  '40': '#000000',
  '41': '#000000',
  '42': '#000000',
  '43': '#01FF49',
  '44': '#73002A',
  '45': '#FF008C',
  '46': '#000000',
  '47': '#FFFFFF',
  '48': '#FFFFFF',
  '49': '#000000',
};

export const TIME_OPTIONS: string[] = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];

export const purchaseItemNotice: Record<StoreItemType, any> = {
  entUnlimit: ['해당 아이템은 입장하려는 방이 풀방인 경우 사용할 수 있습니다.'],
  nickDeco: ['패턴을 무제한으로 다양하게 변경할 수 있습니다.', '이용기간이 끝난 후 효과는 자동으로 노출되지 않습니다.'],
  introEffect: ['이용기간이 끝난 후 효과는 자동으로 노출되지 않습니다.'],
  listUp: [
    '해당 아이템은 구매 후 방송시작 시 설정할 수 있습니다.',
    '이용시간은 프리미엄 2시간,골드 1시간입니다.',
    '아이템 유효기간은 사용설정 기준이며, 방송종료 시 유효시간 내 재사용 가능합니다.',
    '리스트업 아이템은 자동연장 되지 않습니다.',
    '리스트업 아이템 사용이 끝난 후에는 일반 리스트로 위치가 이동합니다.',
  ],
  userUp: [
    '해당 아이템은 구매 후 방송시작 시 설정할 수 있습니다.',
    '아이템의 유효기간은 5시간입니다.',
    '아이템 유효기간은 사용설정 기준이며,방송종료 시 유효시간 내 재사용 가능합니다.',
    '해당 아이템 사용 시 자동으로 시청가능인원이 최대인원으로 변경됩니다.',
  ],
  pushFan: [
    '해당 아이템은 관리자 승인 후 발송됩니다.',
    '부적절한 내용은 등록이 거절되거나 제재의 대상이 될 수 있습니다.',
  ],
  listDeco: [
    '해당 아이템은 구매 후 방송시작 시 설정할 수 있습니다.',
    '아이템 유효기간은 사용설정 기준이며,방송종료 시 유효시간 내 재사용 가능합니다.',
    '이용기간이 끝난 후 효과는 자동으로 노출되지 않습니다.',
  ],
  onceCoin: [],
};
